import type { HTMLInputTypeAttribute } from 'react';
import { styled } from '@mui/material/styles';

type Props = Readonly<{
  'data-test-id'?: string;
  label: string;
  onChange: (val: string) => void;
  placeholder?: string;
  value: string;
  type?: HTMLInputTypeAttribute;
}>;

const StyledInputWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: '10px',
  label: {
    display: 'flex',
    flex: 1,
    color: '#666',
  },
  input: {
    display: 'flex',
    flex: 2,
    border: '1px solid #999',
    paddingTop: '7px',
    paddingBottom: '7px',
    paddingLeft: '10px',
    paddingRight: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    minWidth: 0,
  },
});

export const LexicalTextInput = ({
  label,
  value,
  onChange,
  placeholder = '',
  'data-test-id': dataTestId,
  type = 'text',
}: Props): JSX.Element => {
  return (
    <StyledInputWrapper className="Input__wrapper">
      <label>{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={e => {
          onChange(e.target.value);
        }}
        data-test-id={dataTestId}
      />
    </StyledInputWrapper>
  );
};
